import { DeliveryNoteStatus } from '../types/delivery-note-query-row';

/** The backend's own text for the status (`Fakturiert`, `Nicht fakturiert`, `Unbekannt`, `Manuell`). */
export function statusLabel(status: DeliveryNoteStatus | string | null | undefined): string {
  if (!status) return '';
  return typeof status === 'string' ? status : status.displayName || status.code;
}
